import React, { useEffect, useId, useRef } from 'react';
import { XIcon } from '@phosphor-icons/react';
import IconButton from 'components/IconButton';
import useOnEscape from 'hooks/useOnEscape';

export default function Popup({
    visible,
    setVisible,
    children,
    title
}) {

    const titleId = useId();
    const panelRef = useRef(null);

    useOnEscape(visible, () => setVisible(false));

    // Move focus into the dialog when it opens.
    useEffect(() => {
        if (visible) panelRef.current?.focus();
    }, [visible]);

    return (
        <div
            className={`fixed top-0 left-0 w-full h-full bg-black/20 backdrop-blur-sm z-[var(--z-modal)] transition-all duration-300 ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
            onClick={() => setVisible(false)}
        >
            <div
                ref={panelRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                tabIndex={-1}
                className={`bg-white rounded-2xl border border-black/10 shadow-2xl w-full max-w-lg mx-4 md:mx-auto mt-40 focus:outline-none transition-all duration-300 ease-out-quint ${visible ? 'translate-y-0 scale-100' : 'translate-y-3 scale-95'}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className='flex justify-between items-center p-6 border-b border-black/6'>
                    <p id={titleId} className='text-lg font-medium'>{title}</p>
                    <IconButton label='Chiudi' className='text-grey' onClick={() => setVisible(false)}>
                        <XIcon size={20} />
                    </IconButton>
                </div>
                <div className='p-6'>
                    {children}
                </div>
            </div>
        </div>
    )
}
